<page-load-header *ngIf="!initialized"></page-load-header>
<div *ngIf="initialized">
  <div class="row justify-content-md-between">
    <div class="col-md-6 mb-7 mb-md-0">
      <div class="pr-md-4">
        <!-- Title -->
        <div class="mb-3">
          <h2 class="h4">Share and earn 1% of sales</h2>
          <p>Invite someone to create content and earn 1% of their sales for a year!</p>
          <p>Invite a user to consume content and earn 1% of their purchases for a year!</p>
        </div>
        <!-- End Title -->

        <!-- Clipboard Input -->
        <form>
          <div class="js-focus-state mb-2">
            <div class="input-group">
              <input id="referralLink" type="text" class="form-control" value="{{ url }}" />
              <div class="input-group-append">
                <a class="js-clipboard input-group-text" [ngxClipboard] (cbOnSuccess)="copied($event)" [cbContent]="url">
                  <span *ngIf="!copiedVal" id="linkIcon" class="fas fa-clone"></span>
                  <span *ngIf="copiedVal" id="linkIcon" class="fas fa-check"></span>
                </a>
              </div>
            </div>
          </div>
          <small class="form-text text-muted">Copy or share your referral link with friends</small>
        </form>
        <!-- End Clipboard Input -->
      </div>
    </div>
    <div class="col-md-6 col-lg-4">
      <!-- Stats -->
      <div class="bg-alternate  rounded pt-4 pb-5 px-5">
        <!-- Title & Settings -->
        <div class="d-flex justify-content-between align-items-center">
          <h4 class="h6 text-white mb-0">Referrals</h4>

          <!-- Settings Dropdown -->

          <!-- End Settings Dropdown -->
        </div>
        <!-- End Title & Settings -->

        <hr class="opacity-md mt-3 mb-4" />

        <!-- Referral Info -->
        <div class="py-2">
          <div class="row">
            <div class="col-6">
              <div class="mb-3">
                <span class="d-block text-white-70 font-size-1">Overall:</span>
                <span class="align-top text-white">$</span>
                <span class="text-white font-size-3 font-weight-medium text-lh-sm">{{ stats.sum | number: '.2-2':'en' }}</span>
              </div>
            </div>

            <div class="col-6 align-self-end">
              <!-- Pie Circle -->
              <div class="js-pie text-center" data-circles-text-class="content-centered-y" data-circles-value="54" data-circles-max-value="100" data-circles-bg-color="rgba(255, 255, 255, 0.1)" data-circles-fg-color="#ffffff" data-circles-radius="50" data-circles-stroke-width="4" data-circles-duration="2000" data-circles-scroll-animate="true" data-circles-color="#ffffff" data-circles-font-size="24" id="hs-pie-1">
                <div class="u-circles-wrap" style="position: relative; display: inline-block;">
                  <svg xmlns="http://www.w3.org/2000/svg" width="100" height="100">
                    <path fill="transparent" stroke="#ffffff" stroke-width="4" d="M 49.990223686222635 2.000000995586582 A 48 48 0 1 1 49.93332896297256 2.0000463023887676 Z" class="u-circles-maxValueStroke"></path>
                    <path fill="transparent" stroke="#ffffff" stroke-width="4" d="M 49.990223686222635 2.000000995586582 A 48 48 0 1 1 38.11513781023752 96.5053765787393 " class="u-circles-valueStroke"></path>
                  </svg>
                  <div class="content-centered-y" style="position: absolute; text-align: center; width: 100%; font-size: 24px; height: auto; line-height: normal; color: rgb(255, 255, 255);">{{ stats.count }}</div>
                </div>
              </div>
              <!-- End Pie Circle -->
            </div>
          </div>
        </div>
        <!-- End Referral Info -->
      </div>
      <!-- End Stats -->
    </div>
  </div>

  <hr class="my-7" />

  <!-- Title -->
  <div class="mb-3">
    <h2 class="h4">Why Invite Your Friends?</h2>
  </div>
  <!-- End Title -->

  <!-- Icon Blocks -->
  <div class="row">
    <div class="col-md-4 mb-9 mb-md-0">
      <!-- Card -->
      <div class="card bg-transparent border-0 h-100">
        <div class="card-header bg-transparent border-0 p-0">
          <figure id="SVGanalysis" [inlineSVG]="'../../assets/svg/illustrations/we-are-in-office.svg'" class="mb-3"></figure>
        </div>
        <div class="card-body bg-transparent border-0 p-0">
          <h4 class="h5">Refer friends</h4>
          <p>Share your referral link with friends and colleagues via social media or email.</p>
        </div>
      </div>
      <!-- End Card -->
    </div>

    <div class="col-md-4 mb-9 mb-md-0">
      <!-- Card -->
      <div class="card bg-transparent border-0 h-100">
        <div class="card-header bg-transparent border-0 p-0">
          <figure id="SVGinTheOffice" [inlineSVG]="'../../assets/svg/illustrations/we-are-in-office-2.svg'" class="mb-3"></figure>
        </div>
        <div class="card-body bg-transparent border-0 p-0">
          <h4 class="h5">They Sign Up</h4>
          <p>When a referral signs up, they will be linked to your account and their sales/spend will be tracked.</p>
        </div>
      </div>
      <!-- End Card -->
    </div>

    <div class="col-md-4">
      <!-- Card -->
      <div class="card bg-transparent border-0 h-100">
        <div class="card-header bg-transparent border-0 p-0">
          <figure id="SVGmakeItRain" [inlineSVG]="'../../assets/svg/illustrations/person-with-boards.svg'" class="mb-3"></figure>
        </div>
        <div class="card-body bg-transparent border-0 p-0">
          <h4 class="h5">You Get paid</h4>
          <p>When speakers sell courses, or users purchase courses, you will get 1% of those purchases for a year!</p>
        </div>
      </div>
      <!-- End Card -->
    </div>
  </div>
  <!-- End Icon Blocks -->
</div>
